import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import authService from "../../services/authService";
import { Modal, Button } from "react-bootstrap";

function formatPhoneNumber(phoneNumber) {
  if (typeof phoneNumber !== "string" || phoneNumber.length !== 12) {
    return "+X (XXX) XXX-XXXX";
  }

  const countryCode = phoneNumber.substring(0, 2);
  const areaCode = phoneNumber.substring(2, 5);
  const firstPart = phoneNumber.substring(5, 8);
  const secondPart = phoneNumber.substring(8);

  return `${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
}

const LeftNav = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout, token } = useUser();

  // Check if user has a phone number
  const hasPhoneNumber = user?.phone_number && user.phone_number.length === 12;
  const phoneNumber = hasPhoneNumber
    ? formatPhoneNumber(user.phone_number)
    : "+X (XXX) XXX-XXXX";

  // Determine container class based on whether user has a phone number
  const containerClass = hasPhoneNumber
    ? "mt-4 mb-3 p-3 fs-one bg-light-subtle rounded-4"
    : showMessage
    ? "mt-4 mb-3 p-3 fs-one bg-light-subtle rounded-4"
    : "mt-4 mb-3 p-3 fs-one bg-light-subtle border border-danger rounded-4";

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleActivateNumber = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowMessage(true);
  };

  const handleConfirmActivate = () => {
    // Logic for activating the number - to be implemented later
    console.log("Number activated");
    setShowModal(false);
    setShowMessage(true);
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const data = await authService.getUser(token);
        setUserInfo(data);
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserDetails();
  }, [token]);

  return (
    <nav className="left-nav d-flex flex-column justify-content-between h-100 border-end border-light-subtle">
      <div className="px-lg-3 py-2">
        <div className="left-nav-header px-lg-3 mt-lg-4">
          <NavLink
            to="/overview"
            className="purple-color fw-bold fs-5 text-decoration-none"
          >
            Nouraa
          </NavLink>
        </div>
        <ul className="list-unstyled mt-5">
          {/* <li className="mb-2">
            <NavLink
              to="/guided_setup"
              className={`d-flex align-items-center text-decoration-none fw-bold gray-color ${
                location.pathname === "/guided_setup" ? "active" : ""
              }`}
            >
              <img src="/assets/file.svg" alt="Home" className="nav-icon" />
              Guided Setup
            </NavLink>
          </li> */}
          <li className="mb-2">
            <NavLink
              to="/overview"
              className={`d-flex align-items-center text-decoration-none fw-bold gray-color ${
                location.pathname === "/overview" ? "active" : ""
              }`}
            >
              <img
                src="/assets/bar-chart-2.svg"
                alt="About"
                className="nav-icon"
              />
              Overview
            </NavLink>
          </li>
          <li className="mb-2">
            <NavLink
              to="/agent_settings"
              className={`d-flex align-items-center text-decoration-none fw-bold gray-color ${
                location.pathname === "/agent_settings" ? "active" : ""
              }`}
            >
              <img
                src="/assets/agent.svg"
                alt="Services"
                className="nav-icon"
              />
              Agent Settings
            </NavLink>
          </li>
          <li className="mb-5">
            <NavLink
              to="/test_noura"
              className={`d-flex align-items-center text-decoration-none fw-bold gray-color ${
                location.pathname === "/test_noura" ? "active" : ""
              }`}
            >
              <img
                src="/assets/fluent-mic.svg"
                alt="About"
                className="nav-icon"
              />
              <div className="d-flex flex-column">
                <span className="fw-bold">Test Nouraa</span>
                <span className="fs-one gray-color fw-normal">
                  Voice Interaction
                </span>
              </div>
            </NavLink>
          </li>
          {/* Superadmin-only links */}
          {user?.role === "superadmin" && (
            <>
              <li className="mb-2">
                <NavLink
                  to="/user_management"
                  className={`d-flex align-items-center text-decoration-none fw-bold gray-color ${
                    location.pathname === "/user_management" ? "active" : ""
                  }`}
                >
                  <img
                    src="/assets/users.svg"
                    alt="User Management"
                    className="nav-icon"
                  />
                  User Management
                </NavLink>
              </li>
              <li className="mb-2">
                <NavLink
                  to="/test_box"
                  className={`d-flex align-items-center text-decoration-none fw-bold gray-color ${
                    location.pathname === "/test_box" ? "active" : ""
                  }`}
                >
                  <img
                    src="/assets/Plus.svg"
                    alt="Test Box"
                    className="nav-icon"
                  />
                  Test Box
                </NavLink>
              </li>
            </>
          )}
        </ul>
        <ul className="list-unstyled empty-space-mt">
          <li className="mb-2 disabled-integration">
            <a
              href="/#"
              title="Disabled"
              className="d-flex align-items-center text-decoration-none fw-bold gray-color disabled"
              onClick={(e) => e.preventDefault()} // Prevent default action
            >
              <img
                src="/assets/grid.svg"
                alt="Integration"
                className="nav-icon"
              />
              Integration
            </a>
          </li>
          <li>
            <NavLink
              to="/billing"
              className={`d-flex align-items-center text-decoration-none fw-bold gray-color ${
                location.pathname === "/billing" ? "active" : ""
              }`}
            >
              <img
                src="/assets/stash_billing-info.svg"
                alt="Billing"
                className="nav-icon"
              />
              Billing
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/notification"
              className={`d-flex align-items-center text-decoration-none fw-bold gray-color ${
                location.pathname === "/notification" ? "active" : ""
              }`}
            >
              <img
                src="/assets/bell.svg"
                alt="notification"
                className="nav-icon"
              />
              Notification
            </NavLink>
          </li>
        </ul>
        <div className={containerClass}>
          <h6 className="fs-one gray-color fw-bold">Call Phone Number</h6>
          <div className="d-flex align-items-center my-4">
            <img
              src="/assets/phone.svg"
              alt="Phone"
              className="me-2 p-2 bg-icon"
            />
            <span className="gray-color fw-bold">{phoneNumber}</span>
          </div>
          <hr className="border-dark-subtle m-0" />
          <div className="activate-number-btn-wrapper">
            <div className="progress my-3">
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: `${
                    (Number(userInfo?.remainingMinutes) /
                      Number(userInfo?.totalMinutes)) *
                    100
                  }%`,
                }}
                aria-valuenow={Number(userInfo?.remainingMinutes)}
                aria-valuemin="0"
                aria-valuemax={Number(userInfo?.totalMinutes)}
              ></div>
            </div>
            {isLoading ? (
              <p className="fw-bold gray-color py-2">...</p>
            ) : (
              <p className="fw-bold gray-color py-2">
                {Math.floor(
                  Number(userInfo?.remainingMinutes) > 0
                    ? Number(userInfo?.remainingMinutes)
                    : 0
                )}{" "}
                of {userInfo?.totalMinutes} mins left
              </p>
            )}
            {/* Only show activation button or message if user doesn't have a phone number */}
            {!hasPhoneNumber &&
              (!showMessage ? (
                <button
                  className="btn btn-outline-danger fw-bold w-100"
                  onClick={handleActivateNumber}
                >
                  Activate Your Number
                </button>
              ) : (
                <p className="fw-bold text-success">
                  Your number will be loaded shortly
                </p>
              ))}
          </div>
        </div>
      </div>
      <hr className="mt-4 border-dark-subtle" />
      <div className="left-nav-footer px-lg-4 py-4 d-flex justify-content-between align-items-center">
        <span className="or-text purple-color fw-bold fs-one">OR</span>
        <div className="d-flex ps-lg-2 flex-column align-items-start fs-one">
          <span className="gray-color fw-bold text-break">{user?.email}</span>
        </div>
        <button
          onClick={handleLogout}
          style={{ background: "none", border: "none", cursor: "pointer" }}
        >
          <img src="/assets/log-out.svg" alt="Logout" className="ms-2" />
        </button>
      </div>
      {/* Modal for confirmation */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="fs-three">Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="my-5 text-center">
          Your request has been sent to support. The number will be available
          shortly.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="bg-purple-color fw-bold text-white"
            onClick={handleConfirmActivate}
          >
            Okay
          </Button>
        </Modal.Footer>
      </Modal>
    </nav>
  );
};

export default LeftNav;
